webpackJsonp([50],{

/***/ 1301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_diagnoses_summary_vue__ = __webpack_require__(1971);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a23aa6b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_diagnoses_summary_vue__ = __webpack_require__(2584);
function injectStyle (ssrContext) {
  __webpack_require__(2559)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a23aa6b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_diagnoses_summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a23aa6b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_diagnoses_summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'title-header',
	props: {
		gray: {
			type: Boolean,
			default: false
		},
		pbZero: {
			type: Boolean,
			default: false
		},
		pollName: String,
		title: String,
		urlImage: String
	}
});

/***/ }),

/***/ 1482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'download-btn',
	props: {
		alt: String,
		disabled: {
			type: Boolean,
			default: false
		},
		height: [Number, String],
		urlImage: String
	}
});

/***/ }),

/***/ 1487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_title_header_vue__ = __webpack_require__(1460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbead12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_title_header_vue__ = __webpack_require__(1490);
function injectStyle (ssrContext) {
  __webpack_require__(1488)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdbead12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_title_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbead12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_title_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1489);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("6a611bf6", content, true, {});

/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.title-header .text[data-v-bdbead12]{font-family:NeuzeitGroTBold;font-size:18px}.title-header .wrapper[data-v-bdbead12]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e7e7e7;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px 10px}.title-header .wrapper.pb-0[data-v-bdbead12]{padding-bottom:0}.subtitle-header[data-v-bdbead12]{font-family:NeuzeitGroT;font-size:18px}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/title-header.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,4BAA+B,AAC/B,cAAgB,CACjB,AACD,wCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAiC,AACjC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,kBAAoB,CACrB,AACD,6CACI,gBAAoB,CACvB,AACD,kCACE,wBAA2B,AAC3B,cAAgB,CACjB","file":"title-header.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.title-header .text[data-v-bdbead12] {\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 18px;\n}\n.title-header .wrapper[data-v-bdbead12] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: 1px solid #e7e7e7;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 5px 10px;\n}\n.title-header .wrapper.pb-0[data-v-bdbead12] {\n    padding-bottom: 0px;\n}\n.subtitle-header[data-v-bdbead12] {\n  font-family: \"NeuzeitGroT\";\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-header"},[_c('div',{staticClass:"wrapper",class:{ 'pb-0': _vm.pbZero }},[_c('div',[(_vm.urlImage)?_c('img',{staticClass:"mr-2",attrs:{"src":_vm.urlImage,"alt":_vm.urlImage}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text",style:(("color:" + (_vm.gray ? _vm.$appColors.info : _vm.$appColors.primary)))},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.title)+" "),(_vm.pollName)?_c('span',{staticClass:"subtitle-header"},[_vm._v("- "+_vm._s(_vm.pollName))]):_vm._e()])]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_btn_vue__ = __webpack_require__(1482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1630ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_btn_vue__ = __webpack_require__(1517);
function injectStyle (ssrContext) {
  __webpack_require__(1515)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d1630ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_btn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1630ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_btn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1516);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("36543dd7", content, true, {});

/***/ }),

/***/ 1516:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.download-btn[data-v-5d1630ab]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff!important;border-radius:2px!important;display:-webkit-box;display:-ms-flexbox;display:flex;height:45px!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:5px;width:45px!important}.download-btn-img[data-v-5d1630ab]{height:27px!important}.download-btn[data-v-5d1630ab]:disabled{cursor:not-allowed;opacity:.5}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/download-btn.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,+BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAqC,AACrC,4BAA8B,AAC9B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAwB,AACxB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAAiB,AACjB,oBAAuB,CACxB,AACD,mCACI,qBAAwB,CAC3B,AACD,wCACI,mBAAoB,AACpB,UAAa,CAChB","file":"download-btn.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.download-btn[data-v-5d1630ab] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #ffffff !important;\n  border-radius: 2px !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 45px !important;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-left: 5px;\n  width: 45px !important;\n}\n.download-btn-img[data-v-5d1630ab] {\n    height: 27px !important;\n}\n.download-btn[data-v-5d1630ab]:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"download-btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('download-item')}}},[_c('img',{staticClass:"download-btn-img",attrs:{"src":_vm.urlImage,"alt":_vm.alt}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function openApplicants() {
	this.$emit('open-applicants');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'row-graphic',
	methods: {
		openApplicants: openApplicants
	},
	props: {
		applicants: [Number, String],
		average: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		border: {
			type: Boolean,
			default: true
		},
		gray: {
			type: Boolean,
			default: false
		},
		legends: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		legendBorderRight: {
			default: false,
			type: Boolean
		},
		row: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		totalApplicants: [Number, String],
		viewApplicants: {
			type: Boolean,
			default: false
		},
		viewLegend: {
			type: Boolean,
			default: false
		},
		withoutBackground: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 1533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	WorkingEnvironment: 'WEV',
	OrgaDiagnosis: 'ODG',
	OrgaCultureInventory: 'OCI'
});

/***/ }),

/***/ 1549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_graphic_vue__ = __webpack_require__(1523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d27910e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_graphic_vue__ = __webpack_require__(1583);
function injectStyle (ssrContext) {
  __webpack_require__(1581)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d27910e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_graphic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d27910e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_graphic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("469ab066", content, true, {});

/***/ }),

/***/ 1582:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.number-diagnosis[data-v-d27910e4]{font-size:12px;font-weight:700}.description[data-v-d27910e4]{font-size:10px}.container-diagnosis[data-v-d27910e4]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative}.container-diagnosis[data-v-d27910e4]:last-child:before{content:none}.text-blue[data-v-d27910e4]{display:inline-block;font-size:10px;font-weight:700;max-width:54px}.border[data-v-d27910e4]{border:1px solid #e7e7e7}.gray-color[data-v-d27910e4]{background:transparent}.btn-image[data-v-d27910e4]{border-radius:13px;-webkit-box-shadow:none!important;box-shadow:none!important;color:#fff!important;height:27px;margin:0;text-transform:none!important;width:158px!important}.number-bold[data-v-d27910e4]{font-family:NeuzeitGroTBold;font-size:16px;margin-right:4px}.text-small[data-v-d27910e4]{font-size:10px}.wrapper-btn[data-v-d27910e4]{padding:0 15px 0 0;position:relative}.wrapper-btn[data-v-d27910e4]:before{bottom:0;content:\"\";height:19px;position:absolute;right:0;top:4px;width:2px}.color-legend[data-v-d27910e4]{display:inline-block;height:19px;margin-right:4px;vertical-align:middle;width:19px}.color-legend-average[data-v-d27910e4]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:13.5px;display:-webkit-box;display:-ms-flexbox;display:flex;height:27px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:108px}.color-legend-average .text-big-gray[data-v-d27910e4]{color:#fff!important}.text-big-gray[data-v-d27910e4]{font-size:14px}.alig-center[data-v-d27910e4]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.no-display[data-v-d27910e4]{display:none}.border-right-blue[data-v-d27910e4]{border-right:2px solid #f09c2b}", "", {"version":3,"sources":["/opt/build/repo/src/components/surveys/action-one/row-graphic.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,mCACE,eAAgB,AAChB,eAAkB,CACnB,AACD,8BACE,cAAgB,CACjB,AACD,sCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAmB,CACpB,AACD,wDACI,YAAc,CACjB,AACD,4BACE,qBAAsB,AACtB,eAAgB,AAChB,gBAAkB,AAClB,cAAgB,CACjB,AACD,yBACE,wBAA0B,CAC3B,AACD,6BACE,sBAAwB,CACzB,AACD,4BACE,mBAAoB,AACpB,kCAAoC,AAC5B,0BAA4B,AACpC,qBAA0B,AAC1B,YAAa,AACb,SAAU,AACV,8BAAgC,AAChC,qBAAwB,CACzB,AACD,8BACE,4BAA+B,AAC/B,eAAgB,AAChB,gBAAkB,CACnB,AACD,6BACE,cAAgB,CACjB,AACD,8BACE,mBAAsB,AACtB,iBAAmB,CACpB,AACD,qCACI,SAAU,AACV,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,QAAS,AACT,QAAS,AACT,SAAW,CACd,AACD,+BACE,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,sBAAuB,AACvB,UAAY,CACb,AACD,uCACI,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,qBAAsB,AACtB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAa,CAChB,AACD,sDACM,oBAA0B,CAC/B,AACD,gCACE,cAAgB,CACjB,AACD,8BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,6BACE,YAAc,CACf,AACD,oCACE,8BAAgC,CACjC","file":"row-graphic.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.number-diagnosis[data-v-d27910e4] {\n  font-size: 12px;\n  font-weight: bold;\n}\n.description[data-v-d27910e4] {\n  font-size: 10px;\n}\n.container-diagnosis[data-v-d27910e4] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative;\n}\n.container-diagnosis[data-v-d27910e4]:last-child::before {\n    content: none;\n}\n.text-blue[data-v-d27910e4] {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: bold;\n  max-width: 54px;\n}\n.border[data-v-d27910e4] {\n  border: 1px solid #e7e7e7;\n}\n.gray-color[data-v-d27910e4] {\n  background: transparent;\n}\n.btn-image[data-v-d27910e4] {\n  border-radius: 13px;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  color: #ffffff !important;\n  height: 27px;\n  margin: 0;\n  text-transform: none !important;\n  width: 158px !important;\n}\n.number-bold[data-v-d27910e4] {\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 16px;\n  margin-right: 4px;\n}\n.text-small[data-v-d27910e4] {\n  font-size: 10px;\n}\n.wrapper-btn[data-v-d27910e4] {\n  padding: 0 15px 0 0px;\n  position: relative;\n}\n.wrapper-btn[data-v-d27910e4]::before {\n    bottom: 0;\n    content: '';\n    height: 19px;\n    position: absolute;\n    right: 0;\n    top: 4px;\n    width: 2px;\n}\n.color-legend[data-v-d27910e4] {\n  display: inline-block;\n  height: 19px;\n  margin-right: 4px;\n  vertical-align: middle;\n  width: 19px;\n}\n.color-legend-average[data-v-d27910e4] {\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 13.5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 27px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    width: 108px;\n}\n.color-legend-average .text-big-gray[data-v-d27910e4] {\n      color: #ffffff !important;\n}\n.text-big-gray[data-v-d27910e4] {\n  font-size: 14px;\n}\n.alig-center[data-v-d27910e4] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.no-display[data-v-d27910e4] {\n  display: none;\n}\n.border-right-blue[data-v-d27910e4] {\n  border-right: 2px solid #f09c2b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{class:[_vm.border, { 'gray-color': _vm.gray }, ("" + (_vm.withoutBackground ? '' : 'white')) ],attrs:{"wrap":"","justify-space-around":"","align-center":""}},[(_vm.viewLegend)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-layout',{style:(("border-right:1px solid " + (_vm.$appColors.gray) + ";")),attrs:{"wrap":"","align-center":""}},_vm._l((_vm.legends),function(item,index){return _c('v-flex',{key:index,attrs:{"xs12":"","py-2":""}},[(_vm.average && index > 0)?[_c('span',{staticClass:"color-legend color-legend-average",style:(("background-color: " + (item.color)))},[_c('span',{staticClass:"text-big-gray",style:(("color:" + (_vm.$appColors.info)))},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item.name)+": "+_vm._s(_vm.average[0])+"\n\t\t\t\t\t\t")])])]:[_c('span',{staticClass:"color-legend",style:(("background-color: " + (item.color)))}),_vm._v(" "),_c('span',{staticClass:"text-big-gray",style:(("color:" + (_vm.$appColors.info)))},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t")])]],2)}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{class:("" + (!_vm.viewLegend ? 'xs12' : 'xs10'))},[_c('v-layout',{style:(("border:1px solid " + (_vm.viewApplicants ? _vm.$appColors.gray : 'transparent') + ";")),attrs:{"wrap":"","align-center":""}},[(_vm.viewApplicants)?_c('v-flex',{staticClass:"container-diagnosis",attrs:{"text-xs-center":""}},[_c('v-btn',{staticClass:"btn-image",attrs:{"color":"secondary"},on:{"click":_vm.openApplicants}},[_c('img',{staticClass:"mr-1",attrs:{"src":"/static/img/diagnosis/applicants.svg","alt":"applicants"}}),_vm._v(" "),_c('span',{staticClass:"number-bold"},[_vm._v(_vm._s(_vm.applicants)+" / "+_vm._s(_vm.totalApplicants))]),_vm._v(" "),_c('span',{staticClass:"text-small"},[_vm._v("Aplicantes")])])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.row),function(item,index){return _c('v-flex',{key:index,class:[
					'container-diagnosis',
					{ 'no-display': item.code } ],style:(("color: " + (_vm.$appColors.primary)))},[_c('v-layout',{staticClass:"container-diagnosis-wrap",attrs:{"wrap":"","align-center":"","justify-center":""}},[(item.image)?[_c('img',{staticClass:"flex xs12 lg3 text-xs-center",attrs:{"src":item.image,"alt":item.description,"height":"27"}})]:_vm._e(),_vm._v(" "),(item.textBlue)?_c('v-flex',{attrs:{"xs12":"","lg4":"","text-xs-center":""}},[_c('span',{staticClass:"text-blue",style:(("color:" + (_vm.$appColors.primary)))},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item.textBlue)+"\n\t\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg3":"","text-xs-center":""}},[(!!item.code)?_c('span',{staticClass:"number-diagnosis",style:(("color:" + (_vm.$appColors.info)))},[_vm._v(_vm._s(item.number || 0))]):_c('span',{staticClass:"number-diagnosis",style:(("color:" + (_vm.$appColors.info)))},[_vm._v(_vm._s(item.number)+"/"+_vm._s(item.numberTotal))])]),_vm._v(" "),_c('v-flex',{class:((item.image ? 'lg6' : 'lg5') + " " + (_vm.legendBorderRight && (index < (_vm.row.filter(function (r) { return !r.code; }).length - 1)) ? 'border-right-blue' : '')),attrs:{"xs12":"","text-xs-center":""}},[_c('span',{staticClass:"description",style:(("color:" + (_vm.$appColors.info)))},[_vm._v(_vm._s(item.description))])])],2)],1)})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_diagnosis_select_filter__ = __webpack_require__(2561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_diagnosis_card_chart__ = __webpack_require__(2565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_diagnosis_card_information__ = __webpack_require__(2576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_diagnosis_download_btn__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_helper__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_surveys_action_one_row_graphic__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_diagnosis_title_header__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_tools_codes__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_diagnosis_card_chart_icons__ = __webpack_require__(2580);






var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, newSubsidiary;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$httpPraktiko.get('subsidiaries');

					case 2:
						_ref2 = _context.sent;
						this.subsidiaries = _ref2.data;
						newSubsidiary = { code: 'SUB0', id: null, name: 'Todas las Sucursales' };

						this.subsidiaries.unshift(newSubsidiary);
						this.loadData();

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

var downloadReport = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(type, contentType) {
		var body, myGraphs, graphs, _ref4, pdfData, blob;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						body = {
							id: this.detailId
						};

						if (this.areaId) {
							body.areaId = this.areaId;
						}
						if (this.subsidiaryId) {
							body.subsidiaryId = this.subsidiaryId;
						}
						if (this.employeeId) {
							body.employeeId = this.employeeId;
						}
						myGraphs = document.getElementById('bar-chart').toDataURL();
						graphs = [myGraphs];

						if (type !== 'xlsx') {
							body.base64 = graphs;
						}
						if (type === 'xlsx') {
							body.excel = true;
						}
						_context2.prev = 8;
						_context2.next = 11;
						return this.$httpPraktiko.post('reports/organizational-diagnosis/' + type, body, { responseType: 'blob' });

					case 11:
						_ref4 = _context2.sent;
						pdfData = _ref4.data;
						blob = generateBlob(pdfData, contentType);

						showDownloadDialog(blob, 'reporte_diagnostico_organizacional', type);
						_context2.next = 20;
						break;

					case 17:
						_context2.prev = 17;
						_context2.t0 = _context2['catch'](8);

						if (_context2.t0.status === 500) {
							this.showGenericError();
						}

					case 20:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[8, 17]]);
	}));

	return function downloadReport(_x, _x2) {
		return _ref3.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _this = this;

		var params, request, _ref6, _ref7, activeFactors, employeeIds, param, _ref8, newEmployee, newArea;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {};

						if (this.areaId) {
							params.areaId = this.areaId;
						}
						if (this.subsidiaryId) {
							params.subsidiaryId = this.subsidiaryId;
						}
						if (this.employeeId) {
							params.employeeId = this.employeeId;
						}
						request = [this.$http.get('hierarchies/' + OrgaDiagnosis), this.$httpPraktiko.get('diagnostic-detail/' + this.detailId + '/item', { params: params })];
						_context3.prev = 5;
						_context3.next = 8;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(request);

					case 8:
						_ref6 = _context3.sent;
						_ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);
						this.factors = _ref7[0].data;
						this.model = _ref7[1].data;

						this.graphic = [{
							image: '/static/img/diagnosis/app.svg',
							number: this.areaId || this.subsidiaryId ? this.model.reportData[0].numApplicants : this.model.totalResolved,
							numberTotal: this.areaId || this.subsidiaryId ? this.model.reportData[0].numApplicants : this.model.numApplicants,
							description: 'Aplicantes'
						}, {
							image: '/static/img/diagnosis/male.svg',
							number: this.areaId || this.subsidiaryId ? this.model.reportData[0].numMale : this.model.numMale,
							numberTotal: this.areaId || this.subsidiaryId ? this.model.reportData[0].numMale : this.model.numTotalMale,
							description: 'Masculino'
						}, {
							image: '/static/img/diagnosis/female.svg',
							number: this.areaId || this.subsidiaryId ? this.model.reportData[0].numFemale : this.model.numFemale,
							numberTotal: this.areaId || this.subsidiaryId ? this.model.reportData[0].numFemale : this.model.numTotalFemale,
							description: 'Femenino'
						}, {
							textBlue: 'PROMEDIO DE EDADES',
							number: this.model.averageAge,
							description: 'años',
							code: 'age'
						}, {
							textBlue: 'AÑOS DE SERVICIO',
							number: 10,
							description: 'años',
							code: 'year'
						}];
						this.factorsSelect = this.model.reportData.map(function (r) {
							var newR = {
								id: r.hierarchyId,
								image: r.urlImage,
								percentage: r.percentage,
								percentageAverage: r.percentageAverage
							};
							return newR;
						});
						this.factors = this.factors.map(function (f) {
							var factorSelected = _this.factorsSelect.find(function (fs) {
								return fs.id === f.id;
							});
							var entitySelected = _this.model.reportData.find(function (rd) {
								return rd.hierarchyId === f.id;
							});
							var newF = {
								id: f.id,
								active: !!factorSelected,
								description: entitySelected ? entitySelected.description : '',
								visible: true,
								image: f.urlImage,
								name: f.name,
								percentage: (factorSelected || {}).percentage || 0,
								average: (factorSelected || {}).percentageAverage || 0,
								value: f.percentage || 0,
								numApplicants: _this.model.numApplicants,
								numMale: _this.model.numMale,
								numFemale: _this.model.numFemale
							};
							return newF;
						});
						activeFactors = this.factors.filter(function (f) {
							return f.active;
						});
						employeeIds = this.model.employeeDiagnostic.map(function (emp) {
							return emp.employeeId;
						}).join(',');
						param = { employeeIds: employeeIds };
						_context3.next = 20;
						return this.$httpPraktiko.get('employee', { params: param });

					case 20:
						_ref8 = _context3.sent;
						this.employees = _ref8.data;

						this.employees = this.employees.map(function (e) {
							var newE = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, e);
							newE.fullName = e.name + ' ' + e.lastName;
							return newE;
						});
						newEmployee = { code: 'EMP0', id: null, fullName: 'Todos los Empleados' };

						this.employees.unshift(newEmployee);
						newArea = { code: 'GE01', id: null, name: 'Todas las Áreas' };

						this.model.groups.unshift(newArea);
						this.areas = this.model.groups.map(function (ac) {
							return { code: ac.code, id: ac.id, name: ac.name };
						});
						this.average = activeFactors.map(function (af) {
							return af.average;
						});
						if (this.employeeId) {
							this.percentage = this.model.reportData.map(function (r) {
								return r.entities.map(function (e) {
									return e.value;
								});
							});
							this.seriesLabel = this.model.reportData.map(function (r) {
								return r.entities.map(function (e) {
									return e.name;
								});
							});
						} else {
							this.percentage = activeFactors.map(function (af) {
								return af.percentage;
							});
							this.seriesLabel = this.model.reportData[0].entities.map(function (e) {
								return e.name;
							});
						}
						this.labels = activeFactors.map(function (af) {
							return af.name;
						});
						this.poll = this.model.poll;
						_context3.next = 37;
						break;

					case 34:
						_context3.prev = 34;
						_context3.t0 = _context3['catch'](5);

						if (_context3.t0.status === 500) {
							// this.showGenericError();
							this.showGenericError('No hay coincidencias entre la agencia y el área seleccionada. Asegúrate de que ambos datos sean correctos.');
						}

					case 37:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[5, 34]]);
	}));

	return function loadData() {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var OrgaDiagnosis = __WEBPACK_IMPORTED_MODULE_12__shared_tools_codes__["a" /* default */].OrgaDiagnosis;
var generateBlob = __WEBPACK_IMPORTED_MODULE_9__shared_helper__["a" /* default */].generateBlob,
    showDownloadDialog = __WEBPACK_IMPORTED_MODULE_9__shared_helper__["a" /* default */].showDownloadDialog;


function goToBack() {
	var toolId = this.$route.params.toolId;

	this.goTo('detail-diagnoses', { params: { toolId: toolId, id: this.id } });
}

function changeValue(selection, value) {
	if (selection === 'area') {
		this.areaId = value;
	}
	if (selection === 'subsidiary') {
		this.subsidiaryId = value;
	}
	if (selection === 'employee') {
		this.employeeId = value;
	}
	this.loadData();
}

function data() {
	return {
		areaId: null,
		subsidiaryId: null,
		employeeId: null,
		areas: [],
		areaSelected: null,
		subsidiaries: [],
		subsidiarySelected: null,
		employees: [],
		employeeSelected: null,
		average: [],
		factors: [],
		factorsSelect: [],
		graphic: [],
		labels: [],
		seriesLabel: [],
		legends: [{ color: '#5ed52b', name: 'Porcentaje' }, { color: '#545a54', name: 'Promedio' }],
		model: {},
		percentage: [],
		poll: {}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'diagnoses-summary',
	components: {
		CardChartIcons: __WEBPACK_IMPORTED_MODULE_13__components_diagnosis_card_chart_icons__["a" /* default */],
		// areaFilter,
		// subsidiaryFilter,
		selectFilter: __WEBPACK_IMPORTED_MODULE_5__components_diagnosis_select_filter__["a" /* default */],
		downloadBtn: __WEBPACK_IMPORTED_MODULE_8__components_diagnosis_download_btn__["a" /* default */],
		cardChart: __WEBPACK_IMPORTED_MODULE_6__components_diagnosis_card_chart__["a" /* default */],
		cardInformation: __WEBPACK_IMPORTED_MODULE_7__components_diagnosis_card_information__["a" /* default */],
		rowGraphic: __WEBPACK_IMPORTED_MODULE_10__components_surveys_action_one_row_graphic__["a" /* default */],
		titleHeader: __WEBPACK_IMPORTED_MODULE_11__components_diagnosis_title_header__["a" /* default */]
	},
	created: created,
	data: data,
	methods: {
		downloadReport: downloadReport,
		goToBack: goToBack,
		loadData: loadData,
		changeValue: changeValue
	},
	props: {
		detailId: [Number, String],
		id: [Number, String]
	}
});

/***/ }),

/***/ 1972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'select-filter',
	props: {
		items: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		itemText: {
			type: String,
			default: 'name'
		},
		itemValue: {
			type: String,
			default: 'id'
		},
		selectedValue: {
			type: [Number, String, Object],
			default: null
		},
		eventName: {
			type: String,
			required: true
		}
	},
	methods: {
		handleChange: function handleChange(value) {
			this.$emit(this.eventName, value);
		}
	}
});

/***/ }),

/***/ 1973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_charts_BarChart__ = __webpack_require__(2570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels__ = __webpack_require__(2574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels__);



//
//
//
//
//
//




function data() {
	return {
		dataChart: [44, 49, 48, 49, 55, 47, 43, 55, 53, 43, 44, 51],
		optionsChart: {
			responsive: true,
			legend: {
				display: false,
				position: 'right'
			},
			datasets: {
				bar: {
					categoryPercentage: 0.95,
					barPercentage: 0.8
				}
			},
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
						min: 0,
						max: 100,
						stepSize: 25,
						padding: 14,
						fontColor: '#487fff',
						fontStyle: 'bold'
					},
					gridLines: {
						color: '#e7e7e7',
						display: true,
						drawBorder: false,
						zeroLineColor: '#487fff',
						zeroLineWidth: 2
					},
					position: 'right'
				}],
				xAxes: [{
					gridLines: {
						display: false
					},
					// Configuración para manejar espacios vacíos
					offset: true,
					// Aumentar el ancho de las barras
					barPercentage: 0.7,
					categoryPercentage: 0.8,
					// Configuración para eliminar espacios en blanco
					skipNull: true,
					ticks: {
						autoSkip: false
					}
				}]
			},
			tooltips: {
				enabled: true,
				mode: 'single',
				backgroundColor: 'rgba(33, 41, 52, 0.95)',
				titleFontColor: '#fff',
				titleFontSize: 14,
				bodyFontColor: 'rgba(255, 255, 255, 0.9)',
				bodyFontSize: 13,
				cornerRadius: 8,
				xPadding: 12,
				yPadding: 12,
				displayColors: false,
				bodySpacing: 8,
				caretSize: 6,
				caretPadding: 8,
				borderColor: 'rgba(255, 255, 255, 0.1)',
				borderWidth: 1,
				// Configuración para ajustar el ancho del tooltip
				titleMarginBottom: 10,
				bodyFontStyle: 'normal',
				footerFontStyle: 'normal',
				footerMarginTop: 8,
				// Asegurar que el tooltip tenga un ancho fijo
				titleAlign: 'left',
				bodyAlign: 'left',
				callbacks: {
					// Mostrar el período (Enero, Febrero, etc.)
					title: function title(tooltipItems, datas) {
						if (tooltipItems && tooltipItems.length > 0) {
							var index = tooltipItems[0].index;
							return datas.labels[index] || '';
						}
						return '';
					},
					// Mostrar la serie y el valor en líneas separadas
					label: function label(tooltipItem, datas) {
						// Obtener información del dataset
						var dataset = datas.datasets[tooltipItem.datasetIndex];
						var value = tooltipItem.yLabel;

						// Si el valor es NaN o null, no mostrar tooltip
						if (value === null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(value)) {
							return null;
						}

						// Usar fullLabel si está disponible, sino usar el label normal
						var seriesName = dataset.fullLabel || dataset.label || 'Serie';

						// Si el nombre de la serie es muy largo, dividirlo en múltiples líneas
						// Dividir el texto en palabras
						var words = seriesName.split(' ');
						var maxCharsPerLine = 25; // Máximo de caracteres por línea
						var lines = [];
						var currentLine = '';

						// Construir las líneas
						words.forEach(function (word) {
							if ((currentLine + ' ' + word).length <= maxCharsPerLine) {
								currentLine += (currentLine ? ' ' : '') + word;
							} else {
								lines.push(currentLine);
								currentLine = word;
							}
						});

						// Agregar la última línea
						if (currentLine) {
							lines.push(currentLine);
						}

						// Si hay múltiples líneas, usar esas líneas
						if (lines.length > 1) {
							seriesName = lines;
						}

						// Formatear el valor
						var formattedValue = typeof value === 'number' ? value.toFixed(2) : value;
						// Retornar un array para que cada elemento sea una línea separada
						// Si seriesName ya es un array, extenderlo con el valor
						if (Array.isArray(seriesName)) {
							return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(seriesName), ['Calificaci\xF3n: ' + parseInt(formattedValue, 10)]);
						}
						return [seriesName, 'Porcentaje: ' + formattedValue + '%'];
					},
					// Personalizar el renderizado del tooltip
					labelTextColor: function labelTextColor() {
						return '#fff';
					}
				}
			},
			plugins: {
				datalabels: {
					display: false, // Desactivar completamente las etiquetas de datos
					color: '#487fff',
					anchor: 'end',
					align: 'top',
					font: {
						weight: 'bold'
					},
					formatter: function formatter(value, context) {
						// No mostrar etiquetas para valores NaN o null
						if (value === null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(value)) {
							return null;
						}

						var index = context.datasetIndex;
						if (context.dataset && context.dataset.fullLabel) {
							var seriesName = context.dataset.fullLabel;
							var words = seriesName.split(' ');
							var maxCharsPerLine = 25; // Máximo de caracteres por línea
							var lines = [];
							var currentLine = '';

							// Construir las líneas
							words.forEach(function (word) {
								if ((currentLine + ' ' + word).length <= maxCharsPerLine) {
									currentLine += (currentLine ? ' ' : '') + word;
								} else {
									lines.push(currentLine);
									currentLine = word;
								}
							});

							// Agregar la última línea
							if (currentLine) {
								lines.push(currentLine);
							}

							// Si hay múltiples líneas, usar esas líneas
							if (lines.length > 1) {
								seriesName = lines;
							}
							return value;
						}
						return index === 0 ? value + '%' : value;
					}
				}
			}
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	data: data,
	components: {
		'bar-chart': __WEBPACK_IMPORTED_MODULE_3__components_shared_charts_BarChart__["a" /* default */]
	},
	plugins: [__WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels___default.a],
	computed: {
		chartOptions: function chartOptions() {
			var self = this; // Capturar el contexto de this
			if (this.optionsChart.scales && this.optionsChart.scales.yAxes && this.optionsChart.scales.yAxes.length > 0) {
				this.optionsChart.scales.yAxes[0].ticks.max = this.max;
			}

			// Configuración adicional para manejar valores NaN/null
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.optionsChart, {
				// Configuración para eliminar espacios en blanco por valores nulos
				spanGaps: true,
				// Asegurar que no se muestren etiquetas de datos
				plugins: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.optionsChart.plugins, {
					datalabels: {
						display: false
					}
				}),
				legend: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.optionsChart.legend, {
					onHover: function onHover(event, legendItem) {
						// Obtener el target del evento con validación
						var target = self.getEventTarget(event);

						// Cambiar cursor si tenemos un target válido
						if (target) {
							target.style.cursor = 'pointer';
						}

						var chart = self.$refs.graphComponent && self.$refs.graphComponent.$data &&
						// eslint-disable-next-line
						self.$refs.graphComponent.$data._chart;

						if (chart && chart.data && chart.data.datasets && legendItem.datasetIndex !== undefined) {
							var dataset = chart.data.datasets[legendItem.datasetIndex];

							// Mostrar tooltip solo si hay fullLabel y es diferente al texto truncado
							if (dataset && dataset.fullLabel && dataset.fullLabel !== legendItem.text) {
								self.showCustomTooltip(event, dataset.fullLabel);
							}
						}
					},
					onLeave: function onLeave(event) {
						// Obtener el target del evento con validación
						var target = self.getEventTarget(event);

						// Restaurar cursor si tenemos un target válido
						if (target) {
							target.style.cursor = 'default';
						}

						// Ocultar tooltip
						self.hideCustomTooltip();
					}
				})
			});
		}
	},

	methods: {
		// Helper para obtener el target del evento con validaciones
		getEventTarget: function getEventTarget(event) {
			if (event && event.target) {
				return event.target;
			} else if (event && event.native && event.native.target) {
				return event.native.target;
			}
			return null;
		},
		showCustomTooltip: function showCustomTooltip(event, fullText) {
			// Remover tooltip anterior si existe
			this.hideCustomTooltip();

			// Crear elemento tooltip
			var tooltip = document.createElement('div');
			tooltip.id = 'custom-legend-tooltip';
			tooltip.style.cssText = '\n\t\t\t\tposition: fixed;\n\t\t\t\tbackground: rgba(33, 41, 52, 0.95);\n\t\t\t\tcolor: white;\n\t\t\t\tpadding: 10px 15px;\n\t\t\t\tborder-radius: 8px;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tmax-width: 220px;\n\t\t\t\tword-wrap: break-word;\n\t\t\t\tz-index: 10000;\n\t\t\t\tpointer-events: none;\n\t\t\t\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n\t\t\t\tborder: 1px solid rgba(255, 255, 255, 0.1);\n\t\t\t\tline-height: 1.4;\n\t\t\t';
			tooltip.textContent = fullText;

			// Obtener la posición del target usando el helper
			var target = this.getEventTarget(event);
			var rect = void 0;

			if (target) {
				rect = target.getBoundingClientRect();
			} else {
				// Posición por defecto si no podemos obtener el target
				rect = { left: 100, top: 100, bottom: 120, right: 200 };
			}

			// Posicionar tooltip
			tooltip.style.left = rect.left + 'px';
			tooltip.style.top = rect.bottom + 8 + 'px';

			document.body.appendChild(tooltip);

			// Ajustar posición si se sale de la pantalla
			var tooltipRect = tooltip.getBoundingClientRect();

			if (tooltipRect.right > window.innerWidth) {
				tooltip.style.left = window.innerWidth - tooltipRect.width - 10 + 'px';
			}
			if (tooltipRect.bottom > window.innerHeight) {
				tooltip.style.top = rect.top - tooltipRect.height - 8 + 'px';
			}
		},
		hideCustomTooltip: function hideCustomTooltip() {
			var existingTooltip = document.getElementById('custom-legend-tooltip');
			if (existingTooltip) {
				existingTooltip.remove();
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		// Limpiar tooltip al destruir el componente
		this.hideCustomTooltip();
	},

	props: {
		average: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		labels: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		percentage: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		seriesLabels: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		max: {
			type: Number,
			default: 100
		}
	}
});

/***/ }),

/***/ 1974:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2568), __esModule: true };

/***/ }),

/***/ 1975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		value: 0,
		interval: {},
		visible: false
	};
}

function mouseOver(_ref) {
	var active = _ref.active;

	if (active) {
		this.visible = true;
	}
}

function mouseLeave(_ref2) {
	var active = _ref2.active;

	if (active) {
		this.visible = false;
	}
}

function visible(flag) {
	var _this = this;

	if (flag) {
		this.interval = setInterval(function () {
			if (_this.value > Math.round(_this.data.value * 100) / 100) {
				clearInterval(_this.interval);
			} else {
				_this.value = _this.value;
			}
		}, 10);
	} else {
		this.value = 0;
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'card-information',
	data: data,
	methods: {
		mouseOver: mouseOver,
		mouseLeave: mouseLeave
	},
	props: {
		data: {
			type: Object,
			default: function _default() {}
		}
	},
	watch: {
		visible: visible
	}
});

/***/ }),

/***/ 1976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'card-chart-icons',
	props: {
		icons: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	computed: {
		iconWidth: function iconWidth() {
			var containerWidth = this.$refs.iconWrapper.offsetWidth || 0;
			return containerWidth / this.icons.length + 'px';
		}
	}
});

/***/ }),

/***/ 2559:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2560);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("50fd2652", content, true, {});

/***/ }),

/***/ 2560:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.wrapper-graphic-bar[data-v-a23aa6b0]{width:80%}.graphic-bar[data-v-a23aa6b0]{background:#fff;border:1px solid #c5c5c5;border-radius:4px;-webkit-box-shadow:0 2px 10px 0 hsla(0,0%,95%,.5);box-shadow:0 2px 10px 0 hsla(0,0%,95%,.5);margin-bottom:18px;padding:65px 13% 24px 8%;width:100%}.wrapper-legend-chart[data-v-a23aa6b0]{background:#fff;border:1px solid #c5c5c5;padding:16px 1% 16px 6%;width:100%}.flex[data-v-a23aa6b0]{display:-webkit-box;display:-ms-flexbox;display:flex}.justify-between[data-v-a23aa6b0]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.wrapper-column[data-v-a23aa6b0]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.wrapper-close[data-v-a23aa6b0]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-top:1px solid;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:16px 0 19px;position:fixed;left:70px;right:0}.m-100[data-v-a23aa6b0]{margin-bottom:110px}.mgb-5[data-v-a23aa6b0]{margin-bottom:5px}", "", {"version":3,"sources":["/opt/build/repo/src/pages/diagnosis/page-diagnoses-summary.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,sCACE,SAAW,CACZ,AACD,8BACE,gBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,kDAA0D,AAClD,0CAAkD,AAC1D,mBAAoB,AACpB,yBAA0B,AAC1B,UAAY,CACb,AACD,uCACE,gBAAoB,AACpB,yBAA0B,AAC1B,wBAAyB,AACzB,UAAY,CACb,AACD,uBACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,kCACE,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,iCACE,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,gCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,qBAAsB,AACtB,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAuB,AACvB,eAAgB,AAChB,UAAW,AACX,OAAS,CACV,AACD,wBACE,mBAAqB,CACtB,AACD,wBACE,iBAAmB,CACpB","file":"page-diagnoses-summary.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.wrapper-graphic-bar[data-v-a23aa6b0] {\n  width: 80%;\n}\n.graphic-bar[data-v-a23aa6b0] {\n  background: #ffffff;\n  border: 1px solid #c5c5c5;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);\n          box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);\n  margin-bottom: 18px;\n  padding: 65px 13% 24px 8%;\n  width: 100%;\n}\n.wrapper-legend-chart[data-v-a23aa6b0] {\n  background: #ffffff;\n  border: 1px solid #c5c5c5;\n  padding: 16px 1% 16px 6%;\n  width: 100%;\n}\n.flex[data-v-a23aa6b0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.justify-between[data-v-a23aa6b0] {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.wrapper-column[data-v-a23aa6b0] {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.wrapper-close[data-v-a23aa6b0] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-top: 1px solid;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 16px 0 19px 0;\n  position: fixed;\n  left: 70px;\n  right: 0;\n}\n.m-100[data-v-a23aa6b0] {\n  margin-bottom: 110px;\n}\n.mgb-5[data-v-a23aa6b0] {\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_filter_vue__ = __webpack_require__(1972);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8351a5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_filter_vue__ = __webpack_require__(2564);
function injectStyle (ssrContext) {
  __webpack_require__(2562)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8351a5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8351a5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("5a2b9422", content, true, {});

/***/ }),

/***/ 2563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/select-filter.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB","file":"select-filter.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{staticClass:"body-1 area-filter",style:(("color:" + (_vm.$appColors.primary) + "!important")),attrs:{"color":"primary","height":36,"hide-details":"","item-text":_vm.itemText,"item-value":_vm.itemValue,"items":_vm.items,"outline":"","menu-props":{ contentClass: 'type-select-content' },"value":_vm.selectedValue},on:{"input":_vm.handleChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_chart_vue__ = __webpack_require__(1973);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b223a37_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_chart_vue__ = __webpack_require__(2575);
function injectStyle (ssrContext) {
  __webpack_require__(2566)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b223a37_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2566:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2567);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("2b948286", content, true, {});

/***/ }),

/***/ 2567:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "#custom-legend-tooltip,.chartjs-tooltip{width:220px!important;max-width:220px!important;white-space:normal!important;word-wrap:break-word!important;word-break:break-word!important;overflow-wrap:break-word!important}.tooltip-arrow{position:absolute;bottom:-10px;left:50%;margin-left:-10px;border-width:10px 10px 0;border-style:solid;border-color:rgba(33,41,52,.95) transparent transparent;width:0;height:0}.tooltip-arrow-top{bottom:auto!important;top:-10px!important;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.chartjs-tooltip-key{display:inline-block;width:10px;height:10px;margin-right:10px}#chartjs-tooltip{width:220px!important;max-width:220px!important}#chartjs-tooltip,.chartjs-tooltip-body-item{white-space:normal!important;word-wrap:break-word!important;word-break:break-word!important;overflow-wrap:break-word!important}.chartjs-tooltip-body-item{line-height:1.5!important;margin-bottom:4px!important}.chartjs-tooltip-title{white-space:normal!important;word-wrap:break-word!important;word-break:break-word!important;overflow-wrap:break-word!important;font-weight:700!important;margin-bottom:6px!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/card-chart.vue"],"names":[],"mappings":"AAsYA,wCACC,sBAAwB,AACxB,0BAA4B,AAC5B,6BAA+B,AAC/B,+BAAiC,AACjC,gCAAkC,AAClC,kCAAqC,CACrC,AAGD,eACC,kBAAmB,AACnB,aAAc,AACd,SAAU,AACV,kBAAmB,AACnB,yBAA0B,AAC1B,mBAAoB,AACpB,wDAAyE,AACzE,QAAS,AACT,QAAU,CACV,AAGD,mBACC,sBAAwB,AACxB,oBAAsB,AACtB,iCAAkC,AAC1B,wBAA0B,CAClC,AAGD,qBACC,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,iBAAmB,CACnB,AAGD,iBACC,sBAAwB,AACxB,yBAA4B,CAK5B,AAGD,4CAPC,6BAA+B,AAC/B,+BAAiC,AACjC,gCAAkC,AAClC,kCAAqC,CAWrC,AAPD,2BAKC,0BAA4B,AAC5B,2BAA8B,CAC9B,AAGD,uBACC,6BAA+B,AAC/B,+BAAiC,AACjC,gCAAkC,AAClC,mCAAqC,AACrC,0BAA6B,AAC7B,2BAA8B,CAC9B","file":"card-chart.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Estilo para el tooltip personalizado de la leyenda */\n#custom-legend-tooltip {\n\twidth: 220px !important;\n\tmax-width: 220px !important;\n\twhite-space: normal !important;\n\tword-wrap: break-word !important;\n\tword-break: break-word !important;\n\toverflow-wrap: break-word !important;\n}\n\n/* Estilos para el tooltip de Chart.js */\n.chartjs-tooltip {\n\twidth: 220px !important;\n\tmax-width: 220px !important;\n\twhite-space: normal !important;\n\tword-wrap: break-word !important;\n\tword-break: break-word !important;\n\toverflow-wrap: break-word !important;\n}\n\n/* Flecha del tooltip (apuntando hacia abajo) */\n.tooltip-arrow {\n\tposition: absolute;\n\tbottom: -10px;\n\tleft: 50%;\n\tmargin-left: -10px;\n\tborder-width: 10px 10px 0;\n\tborder-style: solid;\n\tborder-color: rgba(33, 41, 52, 0.95) transparent transparent transparent;\n\twidth: 0;\n\theight: 0;\n}\n\n/* Flecha del tooltip (apuntando hacia arriba) */\n.tooltip-arrow-top {\n\tbottom: auto !important;\n\ttop: -10px !important;\n\t-webkit-transform: rotate(180deg);\n\t        transform: rotate(180deg);\n}\n\n/* Estilos para los tooltips de Chart.js */\n.chartjs-tooltip-key {\n\tdisplay: inline-block;\n\twidth: 10px;\n\theight: 10px;\n\tmargin-right: 10px;\n}\n\n/* Estos estilos se aplicarán a los tooltips de Chart.js */\n#chartjs-tooltip {\n\twidth: 220px !important;\n\tmax-width: 220px !important;\n\twhite-space: normal !important;\n\tword-wrap: break-word !important;\n\tword-break: break-word !important;\n\toverflow-wrap: break-word !important;\n}\n\n/* Estilos para los elementos dentro del tooltip */\n.chartjs-tooltip-body-item {\n\twhite-space: normal !important;\n\tword-wrap: break-word !important;\n\tword-break: break-word !important;\n\toverflow-wrap: break-word !important;\n\tline-height: 1.5 !important;\n\tmargin-bottom: 4px !important;\n}\n\n/* Estilos para el título del tooltip */\n.chartjs-tooltip-title {\n\twhite-space: normal !important;\n\tword-wrap: break-word !important;\n\tword-break: break-word !important;\n\toverflow-wrap: break-word !important;\n\tfont-weight: bold !important;\n\tmargin-bottom: 6px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2568:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2569);
module.exports = __webpack_require__(14).Number.isNaN;


/***/ }),

/***/ 2569:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(24);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ 2570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__ = __webpack_require__(2571);





var reactiveProp = __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__["b" /* mixins */].reactiveProp;


function chartData() {
	this.percentage = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.data));
	return this.percentage;
}

function renderBarChart() {
	var newLabels = this.labels;

	// Verificar si los datos son agrupados (array de arrays) o simples
	var datasets = void 0;

	if (Array.isArray(this.chartData) && Array.isArray(this.chartData[0])) {
		var colors = [
		// Azules
		'#1e3a8a', '#1d4ed8', '#2563eb', '#3b82f6', '#60a5fa', '#93c5fd', '#dbeafe',
		// Verdes
		'#14532d', '#15803d', '#16a34a', '#22c55e', '#4ade80', '#86efac', '#dcfce7',
		// Rojos
		'#7f1d1d', '#dc2626', '#ef4444', '#f87171', '#fca5a5', '#fecaca', '#fee2e2',
		// Amarillos/Naranjas
		'#92400e', '#d97706', '#f59e0b', '#fbbf24', '#fcd34d', '#fde68a', '#fef3c7',
		// Púrpuras
		'#581c87', '#7c3aed', '#8b5cf6', '#a78bfa', '#c4b5fd', '#ddd6fe', '#f3f4f6',
		// Rosas
		'#831843', '#be185d', '#e11d48', '#f43f5e', '#fb7185', '#fda4af', '#fecdd3',
		// Grises
		'#374151', '#4b5563', '#6b7280', '#9ca3af', '#d1d5db', '#e5e7eb', '#f9fafb',
		// Cian/Teal
		'#134e4a', '#0f766e', '#0d9488', '#14b8a6', '#5eead4', '#99f6e4', '#ccfbf1'];

		datasets = [];
		var colorIndex = 0;

		// Iterar sobre cada grupo de datos (cada subarray en chartData)
		for (var groupIndex = 0; groupIndex < this.chartData.length; groupIndex += 1) {
			var currentGroup = this.chartData[groupIndex];
			var currentLabels = this.seriesLabels && this.seriesLabels[groupIndex] ? this.seriesLabels[groupIndex] : [];

			// Iterar sobre cada serie dentro del grupo actual
			for (var seriesIndex = 0; seriesIndex < currentGroup.length; seriesIndex += 1) {
				var fullLabel = currentLabels[seriesIndex] ? currentLabels[seriesIndex] : 'Grupo ' + (groupIndex + 1) + ' - Serie ' + (seriesIndex + 1);

				// Truncar etiqueta para la leyenda (máximo 20 caracteres)
				var truncatedLabel = fullLabel.length > 20 ? fullLabel.substring(0, 20) + '...' : fullLabel;

				// Crear array de datos donde solo el grupo actual tiene valor
				// Usamos undefined en lugar de null o NaN para que Chart.js no dibuje espacios
				var dataArray = new Array(this.chartData.length);

				// Solo asignamos el valor si existe y es válido
				var value = currentGroup[seriesIndex];
				if (value !== null && value !== undefined && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(value)) {
					dataArray[groupIndex] = value;
				}

				datasets.push({
					label: truncatedLabel,
					fullLabel: fullLabel, // Guardamos la etiqueta completa para el tooltip
					backgroundColor: colors[colorIndex % colors.length],
					data: dataArray,
					// Configuración para manejar valores nulos/NaN en Chart.js 2.7
					spanGaps: true
				});

				colorIndex += 1;
			}
		}
	} else {
		// Datos simples: comportamiento original
		var newBackgroundColor = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Array(this.chartData.length || 0))).map(function () {
			return '#5ed52b';
		});

		// Filtrar valores nulos o NaN para evitar espacios en blanco
		var cleanData = [];
		if (this.chartData && this.chartData.length) {
			for (var i = 0; i < this.chartData.length; i += 1) {
				// Solo incluimos el valor si no es null, undefined o NaN
				if (this.chartData[i] !== null && this.chartData[i] !== undefined && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(this.chartData[i])) {
					cleanData[i] = this.chartData[i];
				}
				// Si no, dejamos el índice sin definir (undefined)
			}
		}

		datasets = [{
			backgroundColor: newBackgroundColor,
			data: cleanData,
			// Configuración para manejar valores nulos/NaN en Chart.js 2.7
			spanGaps: true
		}];
	}

	// Asegurarse de que las opciones incluyan spanGaps para manejar valores nulos
	var chartOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.options, {
		spanGaps: true // Configuración global para manejar valores nulos/NaN
	});

	this.renderChart({
		labels: newLabels,
		datasets: datasets
	}, chartOptions);
}

function datachange() {
	/* eslint no-underscore-dangle: ["error", { "allow": ["_chart"] }] */
	this.$data._chart.destroy();
	this.renderBarChart();
}

function data() {
	return {
		percentage: [],
		newlabels: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__["a" /* Bar */],
	mixins: [reactiveProp],
	props: ['data', 'options', 'labels', 'seriesLabels'],
	data: data,
	mounted: function mounted() {
		this.renderBarChart();
	},

	computed: {
		chartData: chartData
	},
	methods: {
		renderBarChart: renderBarChart
	},
	watch: {
		data: datachange,
		options: {
			handler: function handler() {
				if (this.$data._chart) {
					this.$data._chart.destroy();
					this.renderBarChart();
				}
			},

			deep: true
		}
	}
});

/***/ }),

/***/ 2571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VueCharts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_index_js__ = __webpack_require__(2572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseCharts__ = __webpack_require__(2573);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["a"]; });
/* unused harmony reexport HorizontalBar */
/* unused harmony reexport Doughnut */
/* unused harmony reexport Line */
/* unused harmony reexport Pie */
/* unused harmony reexport PolarArea */
/* unused harmony reexport Radar */
/* unused harmony reexport Bubble */
/* unused harmony reexport Scatter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__mixins_index_js__["a"]; });
/* unused harmony reexport generateChart */


var VueCharts = {
  Bar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["a" /* Bar */],
  HorizontalBar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["d" /* HorizontalBar */],
  Doughnut: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["c" /* Doughnut */],
  Line: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["e" /* Line */],
  Pie: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["f" /* Pie */],
  PolarArea: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["g" /* PolarArea */],
  Radar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["h" /* Radar */],
  Bubble: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["b" /* Bubble */],
  Scatter: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["i" /* Scatter */],
  mixins: __WEBPACK_IMPORTED_MODULE_0__mixins_index_js__["a" /* default */],
  generateChart: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["j" /* generateChart */],
  render: function render() {
    return console.error('[vue-chartjs]: This is not a vue component. It is the whole object containing all vue components. Please import the named export or access the components over the dot notation. For more info visit https://vue-chartjs.org/#/home?id=quick-start');
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (VueCharts);


/***/ }),

/***/ 2572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reactiveData */
/* unused harmony export reactiveProp */
function dataHandler(newData, oldData) {
  if (oldData) {
    var chart = this.$data._chart;
    var newDatasetLabels = newData.datasets.map(function (dataset) {
      return dataset.label;
    });
    var oldDatasetLabels = oldData.datasets.map(function (dataset) {
      return dataset.label;
    });
    var oldLabels = JSON.stringify(oldDatasetLabels);
    var newLabels = JSON.stringify(newDatasetLabels);

    if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
      newData.datasets.forEach(function (dataset, i) {
        var oldDatasetKeys = Object.keys(oldData.datasets[i]);
        var newDatasetKeys = Object.keys(dataset);
        var deletionKeys = oldDatasetKeys.filter(function (key) {
          return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
        });
        deletionKeys.forEach(function (deletionKey) {
          delete chart.data.datasets[i][deletionKey];
        });

        for (var attribute in dataset) {
          if (dataset.hasOwnProperty(attribute)) {
            chart.data.datasets[i][attribute] = dataset[attribute];
          }
        }
      });

      if (newData.hasOwnProperty('labels')) {
        chart.data.labels = newData.labels;
        this.$emit('labels:update');
      }

      if (newData.hasOwnProperty('xLabels')) {
        chart.data.xLabels = newData.xLabels;
        this.$emit('xlabels:update');
      }

      if (newData.hasOwnProperty('yLabels')) {
        chart.data.yLabels = newData.yLabels;
        this.$emit('ylabels:update');
      }

      chart.update();
      this.$emit('chart:update');
    } else {
      if (chart) {
        chart.destroy();
        this.$emit('chart:destroy');
      }

      this.renderChart(this.chartData, this.options);
      this.$emit('chart:render');
    }
  } else {
    if (this.$data._chart) {
      this.$data._chart.destroy();

      this.$emit('chart:destroy');
    }

    this.renderChart(this.chartData, this.options);
    this.$emit('chart:render');
  }
}

var reactiveData = {
  data: function data() {
    return {
      chartData: null
    };
  },
  watch: {
    'chartData': dataHandler
  }
};
var reactiveProp = {
  props: {
    chartData: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  watch: {
    'chartData': dataHandler
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  reactiveData: reactiveData,
  reactiveProp: reactiveProp
});

/***/ }),

/***/ 2573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = generateChart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HorizontalBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Doughnut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Pie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PolarArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Radar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Bubble; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Scatter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);

function generateChart(chartId, chartType) {
  return {
    render: function render(createElement) {
      return createElement('div', {
        style: this.styles,
        class: this.cssClasses
      }, [createElement('canvas', {
        attrs: {
          id: this.chartId,
          width: this.width,
          height: this.height
        },
        ref: 'canvas'
      })]);
    },
    props: {
      chartId: {
        default: chartId,
        type: String
      },
      width: {
        default: 400,
        type: Number
      },
      height: {
        default: 400,
        type: Number
      },
      cssClasses: {
        type: String,
        default: ''
      },
      styles: {
        type: Object
      },
      plugins: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    },
    data: function data() {
      return {
        _chart: null,
        _plugins: this.plugins
      };
    },
    methods: {
      addPlugin: function addPlugin(plugin) {
        this.$data._plugins.push(plugin);
      },
      generateLegend: function generateLegend() {
        if (this.$data._chart) {
          return this.$data._chart.generateLegend();
        }
      },
      renderChart: function renderChart(data, options) {
        if (this.$data._chart) this.$data._chart.destroy();
        if (!this.$refs.canvas) throw new Error('Please remove the <template></template> tags from your chart component. See https://vue-chartjs.org/guide/#vue-single-file-components');
        this.$data._chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.$refs.canvas.getContext('2d'), {
          type: chartType,
          data: data,
          options: options,
          plugins: this.$data._plugins
        });
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.$data._chart) {
        this.$data._chart.destroy();
      }
    }
  };
}
var Bar = generateChart('bar-chart', 'bar');
var HorizontalBar = generateChart('horizontalbar-chart', 'horizontalBar');
var Doughnut = generateChart('doughnut-chart', 'doughnut');
var Line = generateChart('line-chart', 'line');
var Pie = generateChart('pie-chart', 'pie');
var PolarArea = generateChart('polar-chart', 'polarArea');
var Radar = generateChart('radar-chart', 'radar');
var Bubble = generateChart('bubble-chart', 'bubble');
var Scatter = generateChart('scatter-chart', 'scatter');
/* unused harmony default export */ var _unused_webpack_default_export = ({
  Bar: Bar,
  HorizontalBar: HorizontalBar,
  Doughnut: Doughnut,
  Line: Line,
  Pie: Pie,
  PolarArea: PolarArea,
  Radar: Radar,
  Bubble: Bubble,
  Scatter: Scatter
});

/***/ }),

/***/ 2574:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * chartjs-plugin-datalabels v0.6.0
 * https://chartjs-plugin-datalabels.netlify.com
 * (c) 2019 Chart.js Contributors
 * Released under the MIT license
 */
(function (global, factory) {
 true ? module.exports = factory(__webpack_require__(201)) :
typeof define === 'function' && define.amd ? define(['chart.js'], factory) :
(global = global || self, global.ChartDataLabels = factory(global.Chart));
}(this, function (Chart) { 'use strict';

Chart = Chart && Chart.hasOwnProperty('default') ? Chart['default'] : Chart;

var helpers = Chart.helpers;

var devicePixelRatio = (function() {
	if (typeof window !== 'undefined') {
		if (window.devicePixelRatio) {
			return window.devicePixelRatio;
		}

		// devicePixelRatio is undefined on IE10
		// https://stackoverflow.com/a/20204180/8837887
		// https://github.com/chartjs/chartjs-plugin-datalabels/issues/85
		var screen = window.screen;
		if (screen) {
			return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
		}
	}

	return 1;
}());

var utils = {
	// @todo move this in Chart.helpers.toTextLines
	toTextLines: function(inputs) {
		var lines = [];
		var input;

		inputs = [].concat(inputs);
		while (inputs.length) {
			input = inputs.pop();
			if (typeof input === 'string') {
				lines.unshift.apply(lines, input.split('\n'));
			} else if (Array.isArray(input)) {
				inputs.push.apply(inputs, input);
			} else if (!helpers.isNullOrUndef(inputs)) {
				lines.unshift('' + input);
			}
		}

		return lines;
	},

	// @todo move this method in Chart.helpers.canvas.toFont (deprecates helpers.fontString)
	// @see https://developer.mozilla.org/en-US/docs/Web/CSS/font
	toFontString: function(font) {
		if (!font || helpers.isNullOrUndef(font.size) || helpers.isNullOrUndef(font.family)) {
			return null;
		}

		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	},

	// @todo move this in Chart.helpers.canvas.textSize
	// @todo cache calls of measureText if font doesn't change?!
	textSize: function(ctx, lines, font) {
		var items = [].concat(lines);
		var ilen = items.length;
		var prev = ctx.font;
		var width = 0;
		var i;

		ctx.font = font.string;

		for (i = 0; i < ilen; ++i) {
			width = Math.max(ctx.measureText(items[i]).width, width);
		}

		ctx.font = prev;

		return {
			height: ilen * font.lineHeight,
			width: width
		};
	},

	// @todo move this method in Chart.helpers.options.toFont
	parseFont: function(value) {
		var global = Chart.defaults.global;
		var size = helpers.valueOrDefault(value.size, global.defaultFontSize);
		var font = {
			family: helpers.valueOrDefault(value.family, global.defaultFontFamily),
			lineHeight: helpers.options.toLineHeight(value.lineHeight, size),
			size: size,
			style: helpers.valueOrDefault(value.style, global.defaultFontStyle),
			weight: helpers.valueOrDefault(value.weight, null),
			string: ''
		};

		font.string = utils.toFontString(font);
		return font;
	},

	/**
	 * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
	 * @todo move this method in Chart.helpers.bound
	 * https://doc.qt.io/qt-5/qtglobal.html#qBound
	 */
	bound: function(min, value, max) {
		return Math.max(min, Math.min(value, max));
	},

	/**
	 * Returns an array of pair [value, state] where state is:
	 * * -1: value is only in a0 (removed)
	 * *  1: value is only in a1 (added)
	 */
	arrayDiff: function(a0, a1) {
		var prev = a0.slice();
		var updates = [];
		var i, j, ilen, v;

		for (i = 0, ilen = a1.length; i < ilen; ++i) {
			v = a1[i];
			j = prev.indexOf(v);

			if (j === -1) {
				updates.push([v, 1]);
			} else {
				prev.splice(j, 1);
			}
		}

		for (i = 0, ilen = prev.length; i < ilen; ++i) {
			updates.push([prev[i], -1]);
		}

		return updates;
	},

	/**
	 * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
	 */
	rasterize: function(v) {
		return Math.round(v * devicePixelRatio) / devicePixelRatio;
	}
};

function orient(point, origin) {
	var x0 = origin.x;
	var y0 = origin.y;

	if (x0 === null) {
		return {x: 0, y: -1};
	}
	if (y0 === null) {
		return {x: 1, y: 0};
	}

	var dx = point.x - x0;
	var dy = point.y - y0;
	var ln = Math.sqrt(dx * dx + dy * dy);

	return {
		x: ln ? dx / ln : 0,
		y: ln ? dy / ln : -1
	};
}

function aligned(x, y, vx, vy, align) {
	switch (align) {
	case 'center':
		vx = vy = 0;
		break;
	case 'bottom':
		vx = 0;
		vy = 1;
		break;
	case 'right':
		vx = 1;
		vy = 0;
		break;
	case 'left':
		vx = -1;
		vy = 0;
		break;
	case 'top':
		vx = 0;
		vy = -1;
		break;
	case 'start':
		vx = -vx;
		vy = -vy;
		break;
	case 'end':
		// keep natural orientation
		break;
	default:
		// clockwise rotation (in degree)
		align *= (Math.PI / 180);
		vx = Math.cos(align);
		vy = Math.sin(align);
		break;
	}

	return {
		x: x,
		y: y,
		vx: vx,
		vy: vy
	};
}

// Line clipping (Cohen–Sutherland algorithm)
// https://en.wikipedia.org/wiki/Cohen–Sutherland_algorithm

var R_INSIDE = 0;
var R_LEFT = 1;
var R_RIGHT = 2;
var R_BOTTOM = 4;
var R_TOP = 8;

function region(x, y, rect) {
	var res = R_INSIDE;

	if (x < rect.left) {
		res |= R_LEFT;
	} else if (x > rect.right) {
		res |= R_RIGHT;
	}
	if (y < rect.top) {
		res |= R_TOP;
	} else if (y > rect.bottom) {
		res |= R_BOTTOM;
	}

	return res;
}

function clipped(segment, area) {
	var x0 = segment.x0;
	var y0 = segment.y0;
	var x1 = segment.x1;
	var y1 = segment.y1;
	var r0 = region(x0, y0, area);
	var r1 = region(x1, y1, area);
	var r, x, y;

	// eslint-disable-next-line no-constant-condition
	while (true) {
		if (!(r0 | r1) || (r0 & r1)) {
			// both points inside or on the same side: no clipping
			break;
		}

		// at least one point is outside
		r = r0 || r1;

		if (r & R_TOP) {
			x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
			y = area.top;
		} else if (r & R_BOTTOM) {
			x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
			y = area.bottom;
		} else if (r & R_RIGHT) {
			y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
			x = area.right;
		} else if (r & R_LEFT) {
			y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
			x = area.left;
		}

		if (r === r0) {
			x0 = x;
			y0 = y;
			r0 = region(x0, y0, area);
		} else {
			x1 = x;
			y1 = y;
			r1 = region(x1, y1, area);
		}
	}

	return {
		x0: x0,
		x1: x1,
		y0: y0,
		y1: y1
	};
}

function compute(range, config) {
	var anchor = config.anchor;
	var segment = range;
	var x, y;

	if (config.clamp) {
		segment = clipped(segment, config.area);
	}

	if (anchor === 'start') {
		x = segment.x0;
		y = segment.y0;
	} else if (anchor === 'end') {
		x = segment.x1;
		y = segment.y1;
	} else {
		x = (segment.x0 + segment.x1) / 2;
		y = (segment.y0 + segment.y1) / 2;
	}

	return aligned(x, y, range.vx, range.vy, config.align);
}

var positioners = {
	arc: function(vm, config) {
		var angle = (vm.startAngle + vm.endAngle) / 2;
		var vx = Math.cos(angle);
		var vy = Math.sin(angle);
		var r0 = vm.innerRadius;
		var r1 = vm.outerRadius;

		return compute({
			x0: vm.x + vx * r0,
			y0: vm.y + vy * r0,
			x1: vm.x + vx * r1,
			y1: vm.y + vy * r1,
			vx: vx,
			vy: vy
		}, config);
	},

	point: function(vm, config) {
		var v = orient(vm, config.origin);
		var rx = v.x * vm.radius;
		var ry = v.y * vm.radius;

		return compute({
			x0: vm.x - rx,
			y0: vm.y - ry,
			x1: vm.x + rx,
			y1: vm.y + ry,
			vx: v.x,
			vy: v.y
		}, config);
	},

	rect: function(vm, config) {
		var v = orient(vm, config.origin);
		var x = vm.x;
		var y = vm.y;
		var sx = 0;
		var sy = 0;

		if (vm.horizontal) {
			x = Math.min(vm.x, vm.base);
			sx = Math.abs(vm.base - vm.x);
		} else {
			y = Math.min(vm.y, vm.base);
			sy = Math.abs(vm.base - vm.y);
		}

		return compute({
			x0: x,
			y0: y + sy,
			x1: x + sx,
			y1: y,
			vx: v.x,
			vy: v.y
		}, config);
	},

	fallback: function(vm, config) {
		var v = orient(vm, config.origin);

		return compute({
			x0: vm.x,
			y0: vm.y,
			x1: vm.x,
			y1: vm.y,
			vx: v.x,
			vy: v.y
		}, config);
	}
};

var helpers$1 = Chart.helpers;
var rasterize = utils.rasterize;

function boundingRects(model) {
	var borderWidth = model.borderWidth || 0;
	var padding = model.padding;
	var th = model.size.height;
	var tw = model.size.width;
	var tx = -tw / 2;
	var ty = -th / 2;

	return {
		frame: {
			x: tx - padding.left - borderWidth,
			y: ty - padding.top - borderWidth,
			w: tw + padding.width + borderWidth * 2,
			h: th + padding.height + borderWidth * 2
		},
		text: {
			x: tx,
			y: ty,
			w: tw,
			h: th
		}
	};
}

function getScaleOrigin(el) {
	var horizontal = el._model.horizontal;
	var scale = el._scale || (horizontal && el._xScale) || el._yScale;

	if (!scale) {
		return null;
	}

	if (scale.xCenter !== undefined && scale.yCenter !== undefined) {
		return {x: scale.xCenter, y: scale.yCenter};
	}

	var pixel = scale.getBasePixel();
	return horizontal ?
		{x: pixel, y: null} :
		{x: null, y: pixel};
}

function getPositioner(el) {
	if (el instanceof Chart.elements.Arc) {
		return positioners.arc;
	}
	if (el instanceof Chart.elements.Point) {
		return positioners.point;
	}
	if (el instanceof Chart.elements.Rectangle) {
		return positioners.rect;
	}
	return positioners.fallback;
}

function drawFrame(ctx, rect, model) {
	var bgColor = model.backgroundColor;
	var borderColor = model.borderColor;
	var borderWidth = model.borderWidth;

	if (!bgColor && (!borderColor || !borderWidth)) {
		return;
	}

	ctx.beginPath();

	helpers$1.canvas.roundedRect(
		ctx,
		rasterize(rect.x) + borderWidth / 2,
		rasterize(rect.y) + borderWidth / 2,
		rasterize(rect.w) - borderWidth,
		rasterize(rect.h) - borderWidth,
		model.borderRadius);

	ctx.closePath();

	if (bgColor) {
		ctx.fillStyle = bgColor;
		ctx.fill();
	}

	if (borderColor && borderWidth) {
		ctx.strokeStyle = borderColor;
		ctx.lineWidth = borderWidth;
		ctx.lineJoin = 'miter';
		ctx.stroke();
	}
}

function textGeometry(rect, align, font) {
	var h = font.lineHeight;
	var w = rect.w;
	var x = rect.x;
	var y = rect.y + h / 2;

	if (align === 'center') {
		x += w / 2;
	} else if (align === 'end' || align === 'right') {
		x += w;
	}

	return {
		h: h,
		w: w,
		x: x,
		y: y
	};
}

function drawTextLine(ctx, text, cfg) {
	var shadow = ctx.shadowBlur;
	var stroked = cfg.stroked;
	var x = rasterize(cfg.x);
	var y = rasterize(cfg.y);
	var w = rasterize(cfg.w);

	if (stroked) {
		ctx.strokeText(text, x, y, w);
	}

	if (cfg.filled) {
		if (shadow && stroked) {
			// Prevent drawing shadow on both the text stroke and fill, so
			// if the text is stroked, remove the shadow for the text fill.
			ctx.shadowBlur = 0;
		}

		ctx.fillText(text, x, y, w);

		if (shadow && stroked) {
			ctx.shadowBlur = shadow;
		}
	}
}

function drawText(ctx, lines, rect, model) {
	var align = model.textAlign;
	var color = model.color;
	var filled = !!color;
	var font = model.font;
	var ilen = lines.length;
	var strokeColor = model.textStrokeColor;
	var strokeWidth = model.textStrokeWidth;
	var stroked = strokeColor && strokeWidth;
	var i;

	if (!ilen || (!filled && !stroked)) {
		return;
	}

	// Adjust coordinates based on text alignment and line height
	rect = textGeometry(rect, align, font);

	ctx.font = font.string;
	ctx.textAlign = align;
	ctx.textBaseline = 'middle';
	ctx.shadowBlur = model.textShadowBlur;
	ctx.shadowColor = model.textShadowColor;

	if (filled) {
		ctx.fillStyle = color;
	}
	if (stroked) {
		ctx.lineJoin = 'round';
		ctx.lineWidth = strokeWidth;
		ctx.strokeStyle = strokeColor;
	}

	for (i = 0, ilen = lines.length; i < ilen; ++i) {
		drawTextLine(ctx, lines[i], {
			stroked: stroked,
			filled: filled,
			w: rect.w,
			x: rect.x,
			y: rect.y + rect.h * i
		});
	}
}

var Label = function(config, ctx, el, index) {
	var me = this;

	me._config = config;
	me._index = index;
	me._model = null;
	me._rects = null;
	me._ctx = ctx;
	me._el = el;
};

helpers$1.extend(Label.prototype, {
	/**
	 * @private
	 */
	_modelize: function(display, lines, config, context) {
		var me = this;
		var index = me._index;
		var resolve = helpers$1.options.resolve;
		var font = utils.parseFont(resolve([config.font, {}], context, index));
		var color = resolve([config.color, Chart.defaults.global.defaultFontColor], context, index);

		return {
			align: resolve([config.align, 'center'], context, index),
			anchor: resolve([config.anchor, 'center'], context, index),
			area: context.chart.chartArea,
			backgroundColor: resolve([config.backgroundColor, null], context, index),
			borderColor: resolve([config.borderColor, null], context, index),
			borderRadius: resolve([config.borderRadius, 0], context, index),
			borderWidth: resolve([config.borderWidth, 0], context, index),
			clamp: resolve([config.clamp, false], context, index),
			clip: resolve([config.clip, false], context, index),
			color: color,
			display: display,
			font: font,
			lines: lines,
			offset: resolve([config.offset, 0], context, index),
			opacity: resolve([config.opacity, 1], context, index),
			origin: getScaleOrigin(me._el),
			padding: helpers$1.options.toPadding(resolve([config.padding, 0], context, index)),
			positioner: getPositioner(me._el),
			rotation: resolve([config.rotation, 0], context, index) * (Math.PI / 180),
			size: utils.textSize(me._ctx, lines, font),
			textAlign: resolve([config.textAlign, 'start'], context, index),
			textShadowBlur: resolve([config.textShadowBlur, 0], context, index),
			textShadowColor: resolve([config.textShadowColor, color], context, index),
			textStrokeColor: resolve([config.textStrokeColor, color], context, index),
			textStrokeWidth: resolve([config.textStrokeWidth, 0], context, index)
		};
	},

	update: function(context) {
		var me = this;
		var model = null;
		var rects = null;
		var index = me._index;
		var config = me._config;
		var value, label, lines;

		// We first resolve the display option (separately) to avoid computing
		// other options in case the label is hidden (i.e. display: false).
		var display = helpers$1.options.resolve([config.display, true], context, index);

		if (display) {
			value = context.dataset.data[index];
			label = helpers$1.valueOrDefault(helpers$1.callback(config.formatter, [value, context]), value);
			lines = helpers$1.isNullOrUndef(label) ? [] : utils.toTextLines(label);

			if (lines.length) {
				model = me._modelize(display, lines, config, context);
				rects = boundingRects(model);
			}
		}

		me._model = model;
		me._rects = rects;
	},

	geometry: function() {
		return this._rects ? this._rects.frame : {};
	},

	rotation: function() {
		return this._model ? this._model.rotation : 0;
	},

	visible: function() {
		return this._model && this._model.opacity;
	},

	model: function() {
		return this._model;
	},

	draw: function(chart, center) {
		var me = this;
		var ctx = chart.ctx;
		var model = me._model;
		var rects = me._rects;
		var area;

		if (!this.visible()) {
			return;
		}

		ctx.save();

		if (model.clip) {
			area = model.area;
			ctx.beginPath();
			ctx.rect(
				area.left,
				area.top,
				area.right - area.left,
				area.bottom - area.top);
			ctx.clip();
		}

		ctx.globalAlpha = utils.bound(0, model.opacity, 1);
		ctx.translate(rasterize(center.x), rasterize(center.y));
		ctx.rotate(model.rotation);

		drawFrame(ctx, rects.frame, model);
		drawText(ctx, model.lines, rects.text, model);

		ctx.restore();
	}
});

var helpers$2 = Chart.helpers;

var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

function rotated(point, center, angle) {
	var cos = Math.cos(angle);
	var sin = Math.sin(angle);
	var cx = center.x;
	var cy = center.y;

	return {
		x: cx + cos * (point.x - cx) - sin * (point.y - cy),
		y: cy + sin * (point.x - cx) + cos * (point.y - cy)
	};
}

function projected(points, axis) {
	var min = MAX_INTEGER;
	var max = MIN_INTEGER;
	var origin = axis.origin;
	var i, pt, vx, vy, dp;

	for (i = 0; i < points.length; ++i) {
		pt = points[i];
		vx = pt.x - origin.x;
		vy = pt.y - origin.y;
		dp = axis.vx * vx + axis.vy * vy;
		min = Math.min(min, dp);
		max = Math.max(max, dp);
	}

	return {
		min: min,
		max: max
	};
}

function toAxis(p0, p1) {
	var vx = p1.x - p0.x;
	var vy = p1.y - p0.y;
	var ln = Math.sqrt(vx * vx + vy * vy);

	return {
		vx: (p1.x - p0.x) / ln,
		vy: (p1.y - p0.y) / ln,
		origin: p0,
		ln: ln
	};
}

var HitBox = function() {
	this._rotation = 0;
	this._rect = {
		x: 0,
		y: 0,
		w: 0,
		h: 0
	};
};

helpers$2.extend(HitBox.prototype, {
	center: function() {
		var r = this._rect;
		return {
			x: r.x + r.w / 2,
			y: r.y + r.h / 2
		};
	},

	update: function(center, rect, rotation) {
		this._rotation = rotation;
		this._rect = {
			x: rect.x + center.x,
			y: rect.y + center.y,
			w: rect.w,
			h: rect.h
		};
	},

	contains: function(point) {
		var me = this;
		var margin = 1;
		var rect = me._rect;

		point = rotated(point, me.center(), -me._rotation);

		return !(point.x < rect.x - margin
			|| point.y < rect.y - margin
			|| point.x > rect.x + rect.w + margin * 2
			|| point.y > rect.y + rect.h + margin * 2);
	},

	// Separating Axis Theorem
	// https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
	intersects: function(other) {
		var r0 = this._points();
		var r1 = other._points();
		var axes = [
			toAxis(r0[0], r0[1]),
			toAxis(r0[0], r0[3])
		];
		var i, pr0, pr1;

		if (this._rotation !== other._rotation) {
			// Only separate with r1 axis if the rotation is different,
			// else it's enough to separate r0 and r1 with r0 axis only!
			axes.push(
				toAxis(r1[0], r1[1]),
				toAxis(r1[0], r1[3])
			);
		}

		for (i = 0; i < axes.length; ++i) {
			pr0 = projected(r0, axes[i]);
			pr1 = projected(r1, axes[i]);

			if (pr0.max < pr1.min || pr1.max < pr0.min) {
				return false;
			}
		}

		return true;
	},

	/**
	 * @private
	 */
	_points: function() {
		var me = this;
		var rect = me._rect;
		var angle = me._rotation;
		var center = me.center();

		return [
			rotated({x: rect.x, y: rect.y}, center, angle),
			rotated({x: rect.x + rect.w, y: rect.y}, center, angle),
			rotated({x: rect.x + rect.w, y: rect.y + rect.h}, center, angle),
			rotated({x: rect.x, y: rect.y + rect.h}, center, angle)
		];
	}
});

function coordinates(view, model, geometry) {
	var point = model.positioner(view, model);
	var vx = point.vx;
	var vy = point.vy;

	if (!vx && !vy) {
		// if aligned center, we don't want to offset the center point
		return {x: point.x, y: point.y};
	}

	var w = geometry.w;
	var h = geometry.h;

	// take in account the label rotation
	var rotation = model.rotation;
	var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h / 2 * Math.sin(rotation));
	var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h / 2 * Math.cos(rotation));

	// scale the unit vector (vx, vy) to get at least dx or dy equal to
	// w or h respectively (else we would calculate the distance to the
	// ellipse inscribed in the bounding rect)
	var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
	dx *= vx * vs;
	dy *= vy * vs;

	// finally, include the explicit offset
	dx += model.offset * vx;
	dy += model.offset * vy;

	return {
		x: point.x + dx,
		y: point.y + dy
	};
}

function collide(labels, collider) {
	var i, j, s0, s1;

	// IMPORTANT Iterate in the reverse order since items at the end of the
	// list have an higher weight/priority and thus should be less impacted
	// by the overlapping strategy.

	for (i = labels.length - 1; i >= 0; --i) {
		s0 = labels[i].$layout;

		for (j = i - 1; j >= 0 && s0._visible; --j) {
			s1 = labels[j].$layout;

			if (s1._visible && s0._box.intersects(s1._box)) {
				collider(s0, s1);
			}
		}
	}

	return labels;
}

function compute$1(labels) {
	var i, ilen, label, state, geometry, center;

	// Initialize labels for overlap detection
	for (i = 0, ilen = labels.length; i < ilen; ++i) {
		label = labels[i];
		state = label.$layout;

		if (state._visible) {
			geometry = label.geometry();
			center = coordinates(label._el._model, label.model(), geometry);
			state._box.update(center, geometry, label.rotation());
		}
	}

	// Auto hide overlapping labels
	return collide(labels, function(s0, s1) {
		var h0 = s0._hidable;
		var h1 = s1._hidable;

		if ((h0 && h1) || h1) {
			s1._visible = false;
		} else if (h0) {
			s0._visible = false;
		}
	});
}

var layout = {
	prepare: function(datasets) {
		var labels = [];
		var i, j, ilen, jlen, label;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			for (j = 0, jlen = datasets[i].length; j < jlen; ++j) {
				label = datasets[i][j];
				labels.push(label);
				label.$layout = {
					_box: new HitBox(),
					_hidable: false,
					_visible: true,
					_set: i,
					_idx: j
				};
			}
		}

		// TODO New `z` option: labels with a higher z-index are drawn
		// of top of the ones with a lower index. Lowest z-index labels
		// are also discarded first when hiding overlapping labels.
		labels.sort(function(a, b) {
			var sa = a.$layout;
			var sb = b.$layout;

			return sa._idx === sb._idx
				? sa._set - sb._set
				: sb._idx - sa._idx;
		});

		this.update(labels);

		return labels;
	},

	update: function(labels) {
		var dirty = false;
		var i, ilen, label, model, state;

		for (i = 0, ilen = labels.length; i < ilen; ++i) {
			label = labels[i];
			model = label.model();
			state = label.$layout;
			state._hidable = model && model.display === 'auto';
			state._visible = label.visible();
			dirty |= state._hidable;
		}

		if (dirty) {
			compute$1(labels);
		}
	},

	lookup: function(labels, point) {
		var i, state;

		// IMPORTANT Iterate in the reverse order since items at the end of
		// the list have an higher z-index, thus should be picked first.

		for (i = labels.length - 1; i >= 0; --i) {
			state = labels[i].$layout;

			if (state && state._visible && state._box.contains(point)) {
				return {
					dataset: state._set,
					label: labels[i]
				};
			}
		}

		return null;
	},

	draw: function(chart, labels) {
		var i, ilen, label, state, geometry, center;

		for (i = 0, ilen = labels.length; i < ilen; ++i) {
			label = labels[i];
			state = label.$layout;

			if (state._visible) {
				geometry = label.geometry();
				center = coordinates(label._el._view, label.model(), geometry);
				state._box.update(center, geometry, label.rotation());
				label.draw(chart, center);
			}
		}
	}
};

var helpers$3 = Chart.helpers;

var formatter = function(value) {
	if (helpers$3.isNullOrUndef(value)) {
		return null;
	}

	var label = value;
	var keys, klen, k;
	if (helpers$3.isObject(value)) {
		if (!helpers$3.isNullOrUndef(value.label)) {
			label = value.label;
		} else if (!helpers$3.isNullOrUndef(value.r)) {
			label = value.r;
		} else {
			label = '';
			keys = Object.keys(value);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				label += (k !== 0 ? ', ' : '') + keys[k] + ': ' + value[keys[k]];
			}
		}
	}

	return '' + label;
};

/**
 * IMPORTANT: make sure to also update tests and TypeScript definition
 * files (`/test/specs/defaults.spec.js` and `/types/options.d.ts`)
 */

var defaults = {
	align: 'center',
	anchor: 'center',
	backgroundColor: null,
	borderColor: null,
	borderRadius: 0,
	borderWidth: 0,
	clamp: false,
	clip: false,
	color: undefined,
	display: true,
	font: {
		family: undefined,
		lineHeight: 1.2,
		size: undefined,
		style: undefined,
		weight: null
	},
	formatter: formatter,
	listeners: {},
	offset: 4,
	opacity: 1,
	padding: {
		top: 4,
		right: 4,
		bottom: 4,
		left: 4
	},
	rotation: 0,
	textAlign: 'start',
	textStrokeColor: undefined,
	textStrokeWidth: 0,
	textShadowBlur: 0,
	textShadowColor: undefined
};

/**
 * @see https://github.com/chartjs/Chart.js/issues/4176
 */

var helpers$4 = Chart.helpers;
var EXPANDO_KEY = '$datalabels';

function configure(dataset, options) {
	var override = dataset.datalabels;
	var config = {};

	if (override === false) {
		return null;
	}
	if (override === true) {
		override = {};
	}

	return helpers$4.merge(config, [options, override]);
}

function dispatchEvent(chart, listeners, target) {
	var callback = listeners && listeners[target.dataset];
	if (!callback) {
		return;
	}

	var label = target.label;
	var context = label.$context;

	if (helpers$4.callback(callback, [context]) === true) {
		// Users are allowed to tweak the given context by injecting values that can be
		// used in scriptable options to display labels differently based on the current
		// event (e.g. highlight an hovered label). That's why we update the label with
		// the output context and schedule a new chart render by setting it dirty.
		chart[EXPANDO_KEY]._dirty = true;
		label.update(context);
	}
}

function dispatchMoveEvents(chart, listeners, previous, target) {
	var enter, leave;

	if (!previous && !target) {
		return;
	}

	if (!previous) {
		enter = true;
	} else if (!target) {
		leave = true;
	} else if (previous.label !== target.label) {
		leave = enter = true;
	}

	if (leave) {
		dispatchEvent(chart, listeners.leave, previous);
	}
	if (enter) {
		dispatchEvent(chart, listeners.enter, target);
	}
}

function handleMoveEvents(chart, event) {
	var expando = chart[EXPANDO_KEY];
	var listeners = expando._listeners;
	var previous, target;

	if (!listeners.enter && !listeners.leave) {
		return;
	}

	if (event.type === 'mousemove') {
		target = layout.lookup(expando._labels, event);
	} else if (event.type !== 'mouseout') {
		return;
	}

	previous = expando._hovered;
	expando._hovered = target;
	dispatchMoveEvents(chart, listeners, previous, target);
}

function handleClickEvents(chart, event) {
	var expando = chart[EXPANDO_KEY];
	var handlers = expando._listeners.click;
	var target = handlers && layout.lookup(expando._labels, event);
	if (target) {
		dispatchEvent(chart, handlers, target);
	}
}

// https://github.com/chartjs/chartjs-plugin-datalabels/issues/108
function invalidate(chart) {
	if (chart.animating) {
		return;
	}

	// `chart.animating` can be `false` even if there is animation in progress,
	// so let's iterate all animations to find if there is one for the `chart`.
	var animations = Chart.animationService.animations;
	for (var i = 0, ilen = animations.length; i < ilen; ++i) {
		if (animations[i].chart === chart) {
			return;
		}
	}

	// No render scheduled: trigger a "lazy" render that can be canceled in case
	// of hover interactions. The 1ms duration is a workaround to make sure an
	// animation is created so the controller can stop it before any transition.
	chart.render({duration: 1, lazy: true});
}

Chart.defaults.global.plugins.datalabels = defaults;

var plugin = {
	id: 'datalabels',

	beforeInit: function(chart) {
		chart[EXPANDO_KEY] = {
			_actives: []
		};
	},

	beforeUpdate: function(chart) {
		var expando = chart[EXPANDO_KEY];
		expando._listened = false;
		expando._listeners = {};     // {event-type: {dataset-index: function}}
		expando._datasets = [];      // per dataset labels: [[Label]]
		expando._labels = [];        // layouted labels: [Label]
	},

	afterDatasetUpdate: function(chart, args, options) {
		var datasetIndex = args.index;
		var expando = chart[EXPANDO_KEY];
		var labels = expando._datasets[datasetIndex] = [];
		var visible = chart.isDatasetVisible(datasetIndex);
		var dataset = chart.data.datasets[datasetIndex];
		var config = configure(dataset, options);
		var elements = args.meta.data || [];
		var ilen = elements.length;
		var ctx = chart.ctx;
		var i, el, label;

		ctx.save();

		for (i = 0; i < ilen; ++i) {
			el = elements[i];

			if (visible && el && !el.hidden && !el._model.skip) {
				labels.push(label = new Label(config, ctx, el, i));
				label.update(label.$context = {
					active: false,
					chart: chart,
					dataIndex: i,
					dataset: dataset,
					datasetIndex: datasetIndex
				});
			} else {
				label = null;
			}

			el[EXPANDO_KEY] = label;
		}

		ctx.restore();

		// Store listeners at the chart level and per event type to optimize
		// cases where no listeners are registered for a specific event
		helpers$4.merge(expando._listeners, config.listeners || {}, {
			merger: function(key, target, source) {
				target[key] = target[key] || {};
				target[key][args.index] = source[key];
				expando._listened = true;
			}
		});
	},

	afterUpdate: function(chart, options) {
		chart[EXPANDO_KEY]._labels = layout.prepare(
			chart[EXPANDO_KEY]._datasets,
			options);
	},

	// Draw labels on top of all dataset elements
	// https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
	// https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
	afterDatasetsDraw: function(chart) {
		layout.draw(chart, chart[EXPANDO_KEY]._labels);
	},

	beforeEvent: function(chart, event) {
		// If there is no listener registered for this chart, `listened` will be false,
		// meaning we can immediately ignore the incoming event and avoid useless extra
		// computation for users who don't implement label interactions.
		if (chart[EXPANDO_KEY]._listened) {
			switch (event.type) {
			case 'mousemove':
			case 'mouseout':
				handleMoveEvents(chart, event);
				break;
			case 'click':
				handleClickEvents(chart, event);
				break;
			default:
			}
		}
	},

	afterEvent: function(chart) {
		var expando = chart[EXPANDO_KEY];
		var previous = expando._actives;
		var actives = expando._actives = chart.lastActive || [];  // public API?!
		var updates = utils.arrayDiff(previous, actives);
		var i, ilen, update, label;

		for (i = 0, ilen = updates.length; i < ilen; ++i) {
			update = updates[i];
			if (update[1]) {
				label = update[0][EXPANDO_KEY];
				if (label) {
					label.$context.active = (update[1] === 1);
					label.update(label.$context);
				}
			}
		}

		if (expando._dirty || updates.length) {
			layout.update(expando._labels);
			invalidate(chart);
		}

		delete expando._dirty;
	}
};

// TODO Remove at version 1, we shouldn't automatically register plugins.
// https://github.com/chartjs/chartjs-plugin-datalabels/issues/42
Chart.plugins.register(plugin);

return plugin;

}));


/***/ }),

/***/ 2575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-chart',{ref:"graphComponent",attrs:{"data":_vm.percentage,"labels":_vm.labels,"options":_vm.chartOptions,"series-labels":_vm.seriesLabels}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_information_vue__ = __webpack_require__(1975);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7600e2f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_information_vue__ = __webpack_require__(2579);
function injectStyle (ssrContext) {
  __webpack_require__(2577)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7600e2f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7600e2f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2577:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2578);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("3289f461", content, true, {});

/***/ }),

/***/ 2578:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.card-information[data-v-7600e2f2]{position:relative;height:85px;width:100%}.card-information .text[data-v-7600e2f2]{background:#fff;font-size:11px;padding:0 8px}.card-information .information[data-v-7600e2f2],.card-information .text[data-v-7600e2f2]{border-radius:4px;border:1px solid #e7e7e7;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;left:0;position:absolute;right:0;top:0;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.card-information .information[data-v-7600e2f2]{background-color:#fff;padding:0 7px}.card-information .bold[data-v-7600e2f2]{font-family:NeuzeitGroTBold;font-size:12px}.card-information .f-white[data-v-7600e2f2]{color:#fff}.card-information .text-small[data-v-7600e2f2]{font-size:11px}.card-information .wrapper-name[data-v-7600e2f2]{border-bottom:1px solid #fff}.card-information .opacity[data-v-7600e2f2]{opacity:0}.card-information .not-opacity[data-v-7600e2f2]{opacity:1}.card-information.not-active[data-v-7600e2f2]{opacity:.5}.card-information.active[data-v-7600e2f2]{cursor:pointer}.card-information .center[data-v-7600e2f2]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card-information-description[data-v-7600e2f2]{background-color:#fff;height:83px;opacity:1!important;overflow:auto;position:relative!important;z-index:1!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/card-information.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,mCACE,kBAAmB,AACnB,YAAa,AACb,UAAY,CACb,AACD,yCACI,gBAAoB,AAOpB,eAAgB,AAGhB,aAAe,CAMlB,AACD,yFAhBI,kBAAmB,AACnB,yBAA0B,AAC1B,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAEd,YAAa,AACb,OAAQ,AAER,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,uCAAwC,AACxC,8BAAgC,CAkBnC,AAhBD,gDACI,sBAA0B,AAS1B,aAAe,CAMlB,AACD,yCACI,4BAA+B,AAC/B,cAAgB,CACnB,AACD,4CACI,UAAe,CAClB,AACD,+CACI,cAAgB,CACnB,AACD,iDACI,4BAAiC,CACpC,AACD,4CACI,SAAW,CACd,AACD,gDACI,SAAW,CACd,AACD,8CACI,UAAa,CAChB,AACD,0CACI,cAAgB,CACnB,AACD,2CACI,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,+CACE,sBAA0B,AAC1B,YAAa,AACb,oBAAsB,AACtB,cAAe,AACf,4BAA8B,AAC9B,mBAAsB,CACvB","file":"card-information.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.card-information[data-v-7600e2f2] {\n  position: relative;\n  height: 85px;\n  width: 100%;\n}\n.card-information .text[data-v-7600e2f2] {\n    background: #ffffff;\n    border-radius: 4px;\n    border: 1px solid #e7e7e7;\n    bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 11px;\n    height: 100%;\n    left: 0;\n    padding: 0 8px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    -webkit-transition: all .2s ease-in-out;\n    transition: all .2s ease-in-out;\n}\n.card-information .information[data-v-7600e2f2] {\n    background-color: #ffffff;\n    border-radius: 4px;\n    border: 1px solid #e7e7e7;\n    bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    left: 0;\n    padding: 0 7px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    -webkit-transition: all .2s ease-in-out;\n    transition: all .2s ease-in-out;\n}\n.card-information .bold[data-v-7600e2f2] {\n    font-family: \"NeuzeitGroTBold\";\n    font-size: 12px;\n}\n.card-information .f-white[data-v-7600e2f2] {\n    color: #ffffff;\n}\n.card-information .text-small[data-v-7600e2f2] {\n    font-size: 11px;\n}\n.card-information .wrapper-name[data-v-7600e2f2] {\n    border-bottom: 1px solid #ffffff;\n}\n.card-information .opacity[data-v-7600e2f2] {\n    opacity: 0;\n}\n.card-information .not-opacity[data-v-7600e2f2] {\n    opacity: 1;\n}\n.card-information.not-active[data-v-7600e2f2] {\n    opacity: 0.5;\n}\n.card-information.active[data-v-7600e2f2] {\n    cursor: pointer;\n}\n.card-information .center[data-v-7600e2f2] {\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.card-information-description[data-v-7600e2f2] {\n  background-color: #ffffff;\n  height: 83px;\n  opacity: 1 !important;\n  overflow: auto;\n  position: relative !important;\n  z-index: 1 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"card-information",class:{'not-active': !_vm.data.active, 'active': _vm.data.active},on:{"mouseover":function($event){_vm.mouseOver(_vm.data)},"mouseleave":function($event){_vm.mouseLeave(_vm.data)}}},[(!_vm.visible)?_c('div',{staticClass:"text align-center",class:{'opacity' : _vm.visible, 'not-opacity': !_vm.visible},style:(("color:" + (_vm.$appColors.info)))},[_c('v-layout',[_c('v-flex',{staticClass:"center",attrs:{"xs3":""}},[_c('img',{attrs:{"src":_vm.data.image,"alt":""}})]),_vm._v(" "),_c('v-flex',{staticClass:"d-flex",attrs:{"xs9":"","ml-2":""}},[_c('span',[_vm._v(_vm._s(_vm.data.name))])])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"information align-center",class:{'opacity' : !_vm.visible, 'not-opacity': _vm.visible}},[(false)?_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","d-flex":"","align-center":""}},[_c('v-progress-circular',{attrs:{"rotate":360,"size":40,"width":3,"value":_vm.data.percentage,"color":"#fff"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.data.percentage)+"%\n\t\t\t\t")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","pl-1":""}},[_c('v-layout',{staticClass:"wrapper-name"},[_c('v-flex',{staticClass:"bold f-white",attrs:{"xs3":"","ml-1":""}},[_vm._v(_vm._s(_vm.data.numApplicants))]),_vm._v(" "),_c('v-flex',{staticClass:"f-white text-small",attrs:{"xs8":""}},[_vm._v("Aplicantes")])],1),_vm._v(" "),_c('v-layout',{staticClass:"wrapper-name"},[_c('v-flex',{staticClass:"bold f-white",attrs:{"xs3":"","ml-1":""}},[_vm._v(_vm._s(_vm.data.numMale))]),_vm._v(" "),_c('v-flex',{staticClass:"f-white text-small",attrs:{"xs8":""}},[_vm._v("Masculino")])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"bold f-white",attrs:{"xs3":"","ml-1":""}},[_vm._v(_vm._s(_vm.data.numFemale))]),_vm._v(" "),_c('v-flex',{staticClass:"f-white text-small",attrs:{"xs8":""}},[_vm._v("Femenino")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"card-information-description",style:(("color:" + (_vm.$appColors.info))),attrs:{"xs12":"","caption":""}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.data.description)+"\n\t\t\t")])],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_chart_icons_vue__ = __webpack_require__(1976);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0cdc1a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_chart_icons_vue__ = __webpack_require__(2583);
function injectStyle (ssrContext) {
  __webpack_require__(2581)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0cdc1a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_chart_icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0cdc1a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_chart_icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2581:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("1b1e7b28", content, true, {});

/***/ }),

/***/ 2582:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.card-chart-icons[data-v-a0cdc1a2]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:-20px}.card-chart-icons .icon-container[data-v-a0cdc1a2]{text-align:center}.card-chart-icons .icon-container img[data-v-a0cdc1a2]{max-width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/card-chart-icons.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,gBAAkB,CACnB,AACD,mDACI,iBAAmB,CACtB,AACD,uDACM,cAAgB,CACrB","file":"card-chart-icons.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.card-chart-icons[data-v-a0cdc1a2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: -20px;\n}\n.card-chart-icons .icon-container[data-v-a0cdc1a2] {\n    text-align: center;\n}\n.card-chart-icons .icon-container img[data-v-a0cdc1a2] {\n      max-width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"iconWrapper",staticClass:"card-chart-icons"},_vm._l((_vm.icons),function(factor,indexFac){return _c('div',{key:indexFac,staticClass:"icon-container",style:({ width: _vm.iconWidth})},[_c('img',{attrs:{"src":factor.image,"alt":factor.image}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-header',{staticClass:"mb-4",attrs:{"poll-name":_vm.poll.name,"title":"CÓDIGO ASIGNADO","url-image":"/static/img/diagnosis/dashboard.svg"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-center":""}},[_c('select-filter',{attrs:{"items":_vm.subsidiaries,"selected-value":_vm.subsidiarySelected,"event-name":"change-subsidiary"},on:{"change-subsidiary":function($event){_vm.changeValue('subsidiary', $event)}}}),_vm._v(" "),_c('select-filter',{attrs:{"items":_vm.areas,"selected-value":_vm.areaSelected,"event-name":"change-area"},on:{"change-area":function($event){_vm.changeValue('area', $event)}}}),_vm._v(" "),_c('select-filter',{attrs:{"items":_vm.employees,"selected-value":_vm.employeeSelected,"item-text":"fullName","item-value":"id","event-name":"change-employee"},on:{"change-employee":function($event){_vm.changeValue('employee', $event)}}}),_vm._v(" "),_c('download-btn',{attrs:{"alt":"Descargar reporte en PDF","height":27,"url-image":"/static/img/icons/pdf.svg"},on:{"download-item":function($event){_vm.downloadReport('pdf')}}}),_vm._v(" "),_c('download-btn',{attrs:{"alt":"Descargar reporte en Excel","height":23,"url-image":"/static/img/icons/excel.webp"},on:{"download-item":function($event){_vm.downloadReport('xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel')}}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","pb-5":"","mb-5":""}},[_c('v-flex',{attrs:{"xs10":"","pr-2":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pr-2":""}},[_c('div',{staticClass:"graphic-bar"},[_c('card-chart',{attrs:{"labels":_vm.labels,"percentage":_vm.percentage,"series-labels":_vm.seriesLabel,"max":_vm.employeeId ? 15 : 100}}),_vm._v(" "),_c('div',{staticStyle:{"padding-right":"45px"}},[_c('card-chart-icons',{attrs:{"icons":_vm.factorsSelect}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pr-2":""}},[_c('div',{staticClass:"wrapper-legend-chart flex"},[_c('row-graphic',{attrs:{"average":_vm.average,"border":false,"legend-border-right":"","legends":_vm.legends,"row":_vm.graphic,"view-legend":""}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-3":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((13),function(z){return [(z > 7)?_c('v-flex',{key:z,attrs:{"xs2":"","pr-2":""}},[_c('card-information',{staticClass:"card-bottom",attrs:{"data":_vm.factors[z]}})],1):_vm._e()]})],2)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((8),function(n){return _c('v-flex',{key:n,attrs:{"xs12":""}},[_c('card-information',{staticClass:"card-right mgb-5",attrs:{"data":_vm.factors[n-1]}})],1)}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"wrapper-close",style:(("border-color:" + (_vm.$appColors.gray) + ";background-color:" + (_vm.$appColors.white)))},[_c('v-btn',{staticClass:"btn-detail btn-action ml-5",attrs:{"color":"primary"},on:{"click":_vm.goToBack}},[_vm._v("\n\t\t\tAtrás\n\t\t")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/50.afb4deecc3e0fbb5bb56.js